import React from "react";

// Helper component for rendering required fields as a bullet list
const RequiredFieldsList = ({ requiredFields }) => {
	if (!requiredFields || requiredFields.length === 0) {
		return null;
	}

	return (
		<ul style={{ margin: 0, paddingLeft: 20 }}>
			{requiredFields.map((field, index) => (
				<li key={index}>{field}</li>
			))}
		</ul>
	);
};

export function getProfilingRequirementsDescription(settings) {
	const { mandatoryProfilingEnabled, requiredFields = {} } = settings;

	if (!mandatoryProfilingEnabled) {
		return (
			<span>
				Users can save Documents to LexWorkplace{" "}
				<strong>without being prompted to Profile them</strong> (add
				metadata).
			</span>
		);
	}

	// Use the consistent backend format
	const typeRequired = requiredFields.documentType;
	const statusRequired = requiredFields.documentStatus;
	const tagsRequired = requiredFields.documentTags;

	const hasRequiredFields = typeRequired || statusRequired || tagsRequired;

	if (!hasRequiredFields) {
		return (
			<span>
				When saving Documents to LexWorkplace, users will be{" "}
				<strong>prompted</strong> to Profile them (add metadata) but
				will not be required to.
			</span>
		);
	}

	const requiredFieldsList = [];
	if (typeRequired) requiredFieldsList.push("Document Type");
	if (statusRequired) requiredFieldsList.push("Document Status");
	if (tagsRequired) requiredFieldsList.push("Document Tags");

	return (
		<div>
			<div style={{ marginBottom: 12 }}>
				When saving Documents to LexWorkplace, users will be{" "}
				<strong>required</strong> to Profile them and populate the
				following properties (metadata):
			</div>
			<RequiredFieldsList requiredFields={requiredFieldsList} />
		</div>
	);
}

export function getFileTypeProfilingDescription(
	mandatoryProfilingEnabled,
	excludedFileTypes
) {
	if (!mandatoryProfilingEnabled) {
		return (
			<span>
				Users will <strong>not</strong> be prompted to add metadata when
				uploading <strong>any type of file</strong>.
			</span>
		);
	}

	if (!excludedFileTypes || excludedFileTypes.length === 0) {
		return (
			<span>
				Users <strong>will</strong> be prompted to add metadata when
				uploading <strong>any type of file</strong>.
			</span>
		);
	}

	return (
		<span>
			Users will <strong>not</strong> be prompted to add metadata when
			uploading the following types of files:
		</span>
	);
}

export function getFileTypeExclusionsDescription(
	excludedFileTypes,
	ignoredExtensionOptions
) {
	if (!excludedFileTypes || excludedFileTypes.length === 0) {
		return null;
	}

	// Build a map of categories with their extensions
	const excludedCategories = [];

	excludedFileTypes.forEach((fileType) => {
		// Handle both string values and objects
		const typeValue =
			typeof fileType === "string" ? fileType : fileType.value;

		// Find the matching option to get extensions
		const option = ignoredExtensionOptions?.find(
			(opt) => opt.value === typeValue
		);

		if (option) {
			const extensions = option.extensions.map((ext) => {
				if (ext === "") {
					return "no extension";
				} else {
					return `.${ext}`;
				}
			});

			excludedCategories.push({
				label: option.label,
				extensions: extensions,
			});
		}
	});

	if (excludedCategories.length === 0) {
		return null;
	}

	return excludedCategories;
}
